import { ValidationMessage } from "@/models/validation-message";
import { z } from "zod";

export const getCreateContractSchema = () =>
  z.object({
    name: z.string().nonempty({ message: ValidationMessage.NON_EMPTY }),
    eppsusId: z.number({ required_error: ValidationMessage.NON_EMPTY }),
  });
